export const TIERS_MOCK = {
  status: 200,
  body: {
    status: 200,
    msg: 'OK',
    data: [
      { tierId: 'bet25', currency: 'USD', entryFee: 30, reward: 50 },
      { tierId: 'bet50', currency: 'USD', entryFee: 60, reward: 100 },
      { tierId: 'bet100', currency: 'USD', entryFee: 120, reward: 200 },
      { tierId: 'bet250', currency: 'USD', entryFee: 300, reward: 500 },
      { tierId: 'bet500', currency: 'USD', entryFee: 600, reward: 1000 },
      { tierId: 'bet1000', currency: 'USD', entryFee: 1200, reward: 2000 },
      { tierId: 'bet2500', currency: 'USD', entryFee: 3000, reward: 5000 },
      { tierId: 'bet10000', currency: 'USD', entryFee: 12000, reward: 20000 },
    ],
  },
};
